export const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const months = [
  { id: '01', title: 'Январь' },
  { id: '02', title: 'Февраль' },
  { id: '03', title: 'Март' },
  { id: '04', title: 'Апрель' },
  { id: '05', title: 'Май' },
  { id: '06', title: 'Июнь' },
  { id: '07', title: 'Июль' },
  { id: '08', title: 'Август' },
  { id: '09', title: 'Сентябрь' },
  { id: '10', title: 'Октябрь' },
  { id: '11', title: 'Ноябрь' },
  { id: '12', title: 'Декабрь' },
];

export const smartCaptchaYandexScriptUrl =
  'https://smartcaptcha.yandexcloud.net/captcha.js';

export const COMPILATION_EVENTS_COUNT = 20;

// made for the main page with a city, this URL format can match the template with pages without a city. For level validation middleware.js
export const startUrlWithoutCities = [
  'faq',
  '404',
  'favorites',
  'person-catalog',
  'profile',
  'search',
  'vk-auth',
];
